import React, { PureComponent } from "react";
import history from '@scandipwa/scandipwa/src/util/History';
import RangeSlider from 'Component/RangeSlider/RangeSlider.component';
import { generateQuery, getQueryParam } from '@scandipwa/scandipwa/src/util/Url';

export class CaratFilter extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            caratminvalue: 0,
            caratmaxvalue: 12,
            caratFilterminvalue: 0,
            caratFiltermaxvalue: 12,
            caratchangevalue: false
        }

        this.cahngeCaratminValue.bind(this);
    }

    componentDidMount() {
        const location = window?.location;

        // carat filter
        const queryfilter = getQueryParam("customFilters", location || '');

        if (queryfilter) {
            let caratIndex = queryfilter.indexOf('total_carat_weight:');

            let resultString = caratIndex !== -1 ? queryfilter.substring(caratIndex).split(';')[0].replace("total_carat_weight:", "").split(",") : queryfilter;

            if (caratIndex !== -1) {
                this.setState({
                    caratminvalue: resultString[0],
                    caratmaxvalue: resultString[1],
                    caratFilterminvalue: resultString[0],
                    caratFiltermaxvalue: resultString[1],
                });
            } else {
                this.setState({
                    caratminvalue: 0,
                    caratmaxvalue: 12,
                    caratFilterminvalue: 0,
                    caratFiltermaxvalue: 12,
                });
            }
        }
    }

    cahngefiltercaratminvalue = (e) => {
        this.setState({
            caratminvalue: e.target.value,
            caratchangevalue: true
        });
    }

    cahngefiltercaratmaxvalue = (e) => {
        this.setState({
            caratmaxvalue: e.target.value,
            caratchangevalue: true
        });
    }

    cahngeCaratminValue = (e) => {
        const { caratmaxvalue, caratminvalue } = this.state;
        const location = window?.location;
        const queryfilter = getQueryParam("customFilters", location || '');
        let query = "";

        if (e.code === "Enter" || e.keyCode === 13) {
            if (caratminvalue > 12) {
                this.setState({
                    caratminvalue: 12,
                    caratFilterminvalue: 12
                });
                query = `12,${caratmaxvalue}`;
            } else if (caratminvalue < 0) {
                this.setState({
                    caratminvalue: 0,
                    caratFilterminvalue: 0
                });
                query = `0,${caratmaxvalue}`;
            } else if (caratmaxvalue < caratminvalue) {
                this.setState({
                    caratminvalue: caratmaxvalue,
                    caratFilterminvalue: caratmaxvalue
                });
                query = `${caratmaxvalue},${caratmaxvalue}`;
            } else {
                if (isNaN(caratminvalue)) {
                    this.setState({
                        caratminvalue: 0,
                        caratFilterminvalue: 0
                    });
                    query = `0,${caratmaxvalue}`;
                } else {
                    this.setState({
                        caratminvalue: caratminvalue,
                        caratFilterminvalue: caratminvalue
                    });
                    query = `${caratminvalue},${caratmaxvalue}`;
                }
            }

            this.setState({
                caratchangevalue: false
            });

            if (queryfilter) {
                let caratIndex = queryfilter.indexOf('total_carat_weight:');
                let resultString = caratIndex !== -1 ? queryfilter.substring(caratIndex).split(';') : queryfilter;

                if (caratIndex !== -1) {
                    query = generateQuery({ customFilters: `total_carat_weight:${queryfilter.replace(resultString[0], query)}` }, window.location, history);
                } else {
                    query = generateQuery({ customFilters: queryfilter.concat(`;total_carat_weight:${query}`) }, window.location, history);
                }
            } else {
                query = generateQuery({ customFilters: `total_carat_weight:${query}` }, window.location, history);
            }

            history.push(query);
        }
    }

    cahngeCaratmaxValue = (e) => {
        const { caratminvalue, caratmaxvalue } = this.state;
        const location = window?.location;
        const queryfilter = getQueryParam("customFilters", location || '');
        let query = "";

        if (e.code === "Enter" || e.keyCode === 13) {
            if (caratmaxvalue > 12) {
                this.setState({
                    caratmaxvalue: 12,
                    caratFiltermaxvalue: 12
                })
                query = `${caratminvalue},12`;
            } else if (caratmaxvalue < 0) {
                this.setState({
                    caratmaxvalue: 0,
                    caratFiltermaxvalue: 0
                })
                query = `${caratminvalue},0`;
            } else if (caratmaxvalue < caratminvalue) {
                this.setState({
                    caratmaxvalue: caratminvalue,
                    caratFiltermaxvalue: caratminvalue
                });
                query = `${caratminvalue},${caratminvalue}`;
            } else {
                if (isNaN(caratmaxvalue)) {
                    this.setState({
                        caratmaxvalue: 12,
                        caratFiltermaxvalue: 12
                    });
                    query = `${caratminvalue},12`;
                } else {
                    this.setState({
                        caratmaxvalue: caratmaxvalue,
                        caratFiltermaxvalue: caratmaxvalue
                    });
                    query = `${caratminvalue},${caratmaxvalue}`;
                }
            }

            this.setState({
                caratchangevalue: false
            });

            if (queryfilter) {
                let caratIndex = queryfilter.indexOf('total_carat_weight:');
                let resultString = caratIndex !== -1 ? queryfilter.substring(caratIndex).split(';') : queryfilter;

                if (caratIndex !== -1) {
                    query = generateQuery({ customFilters: `total_carat_weight:${queryfilter.replace(resultString[0], query)}` }, window.location, history);
                } else {
                    query = generateQuery({ customFilters: queryfilter.concat(`;total_carat_weight:${query}`) }, window.location, history);
                }
            } else {
                query = generateQuery({ customFilters: `total_carat_weight:${query}` }, window.location, history);
            }

            history.push(query);
        }
    }

    onCaratinput = (e) => {
        if (this.state.caratchangevalue === false) {
            this.setState({
                caratmaxvalue: e.maxValue,
                caratminvalue: e.minValue,
                caratFiltermaxvalue: e.maxValue,
                caratFilterminvalue: e.minValue
            });
        }
    }

    handleChangeOptions = (e) => {
        const location = window?.location;
        const queryfilter = getQueryParam("customFilters", location || '');
        let query = "";

        if (this.state.caratchangevalue === false) {
            this.setState({
                caratmaxvalue: e.maxValue,
                caratminvalue: e.minValue,
                caratFiltermaxvalue: e.maxValue,
                caratFilterminvalue: e.minValue
            });
        }

        if (queryfilter) {
            let caratIndex = queryfilter.indexOf('total_carat_weight:');
            let resultString = caratIndex !== -1 ? queryfilter.substring(caratIndex).split(';') : queryfilter;

            if (caratIndex !== -1) {
                query = generateQuery({ customFilters: queryfilter.replace(resultString[0], `total_carat_weight:${e.minValue},${e.maxValue}`) }, window.location, history);
            } else {
                query = generateQuery({ customFilters: queryfilter.concat(`;total_carat_weight:${e.minValue},${e.maxValue}`) }, window.location, history);
            }
        } else {
            query = generateQuery({ customFilters: `total_carat_weight:${e.minValue},${e.maxValue}` }, window.location, history);
        }

        history.push(query);
    }

    renderCarat() {
        return (
            <>
                <RangeSlider
                    label={false}
                    min={0}
                    max={12}
                    step={0.1}
                    minValue={this.state.caratFilterminvalue}
                    maxValue={this.state.caratFiltermaxvalue}
                    className={"caratrangeslider"}
                    oninput={(e) => this.onCaratinput(e)}
                    onChange={(e) => this.handleChangeOptions(e)}
                />
                <div className='carat-input-value'>
                    <input
                        className='caratvalue'
                        type='text'
                        value={this.state.caratminvalue}
                        onChange={this.cahngefiltercaratminvalue}
                        onKeyDown={this.cahngeCaratminValue}
                        name='minvalue'
                    />
                    <input
                        className='caratvalue'
                        type='text'
                        value={this.state.caratmaxvalue}
                        onChange={this.cahngefiltercaratmaxvalue}
                        onKeyDown={this.cahngeCaratmaxValue}
                        name='maxvalue'
                    />
                </div>
            </>
        )
    }

    render() {
        return (
            <>
                {this.renderCarat()}
            </>
        );
    }
}

export default CaratFilter;